import { signOut } from 'src/firebase'

// ----------------------------------------------------------------------
// The backend has stopped accepting this session.
//
// `/backoffice` refuses a token that is not a console session with 401 and
// `CONSOLE_SESSION_REQUIRED`: a session from before console sessions were
// marked, or one the account has since ended. Retrying cannot fix that and
// nothing on the screen would explain it, so the console signs out, and the
// login page says why once.
// ----------------------------------------------------------------------

const KEY = 'beast.session.ended'

export const CONSOLE_SESSION_REQUIRED = 'CONSOLE_SESSION_REQUIRED'

export const SESSION_ENDED_MESSAGE = 'Your session has ended. Sign in again.'

interface ErrorBody {
  errors?: { extensions?: { code?: unknown } }[]
}

/** Whether a response body is the backend's console-session refusal. */
export const isConsoleSessionRefusal = (body: unknown): boolean =>
  body !== null &&
  typeof body === 'object' &&
  Array.isArray((body as ErrorBody).errors) &&
  ((body as ErrorBody).errors ?? []).some(
    (error) => error?.extensions?.code === CONSOLE_SESSION_REQUIRED,
  )

let ending = false

/** Signs out once, however many requests were refused together. */
export const consoleSessionEnd = async (
  storage: Storage = sessionStorage,
): Promise<void> => {
  if (ending) {
    return
  }
  ending = true
  storage.setItem(KEY, '1')

  try {
    await signOut()
  } finally {
    ending = false
  }
}

/** Reads the note the sign-out left and removes it. */
export const takeSessionEndedNote = (
  storage: Storage = sessionStorage,
): boolean => {
  const noted = storage.getItem(KEY) === '1'
  storage.removeItem(KEY)
  return noted
}
